import { Injectable } from '@angular/core';
import {API_MAP} from '../../../core/helpers/api.map';
import {Observable, tap} from 'rxjs';
import {Result} from '../../../core/models/result';
import {BaseDataService} from '../../../core/services/base-data.service';
import {Transparency} from '../models/transparency.model';

@Injectable()
export class TransparencyService extends BaseDataService<Transparency>{
  override controller = API_MAP.transparency;

  override get(controller?: string): Observable<Result<any>> {
    return super.get(controller ?? this.controller).pipe(
      tap((d: any) => {
        this.content.set(d.content);
        this.components.set(d.components);
      })
    );
  }
}
